import React, { useCallback, useMemo, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Button, Col, Form, FormGroup, Row,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';

import NewEntityButton from './NewEntityButton';
import { InputField } from '../blocks/edit_blocks';
import { TableScreenWithoutUpdate } from '../blocks/table_block';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';
import { useUser } from '../contexts/user';
import { buildArticleURL, buildNewsURL, buildVideoURL } from '../tools/build_urls';
import { formatDateTime } from '../tools/converters';
import publisher from '../tools/publisher';
import '../css/main.css';

export default function StoryList({
    type, project, isArticle, isVKP, isCybersport,
}) {
    const { permissions } = useUser();

    const gofProject = window.location.pathname.includes('gof.vkplay.ru') && window.location.pathname.includes('static');

    const [data, setData] = useState({
        filter: {},
        results: [],
        previous: 'none',
        next: 'none',
        total_pages: 0,
        current_page: 1,
        API_ENDPOINT_QS: '',
    });

    const API_PARAMS = useMemo(() => {
        if (isCybersport || isVKP) {
            return `?tag=${isCybersport ? 'cybersport' : ''}${isVKP ? 'vkplay' : ''}`;
        }

        return '';

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCybersport, project, isVKP]);

    const API_ENDPOINT = `v2/${project}/story/${type}/`;

    const buildStoryUrl = useCallback(({ slug, date }) => {
        if (isArticle) {
            return buildArticleURL(type, slug);
        }

        if (type === 'news') {
            return buildNewsURL(date, slug);
        }

        if (type === 'videos') {
            return buildVideoURL(slug);
        }

        return '';
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isArticle, project, isVKP, type]);

    const buildStoryAdminUrl = useCallback(({ id }) => {
        const baseUrl = `${project}/story/${type}/${id}/`;

        // if (isArticle) {
        //     baseUrl = `articles/${baseUrl}`;
        // }

        return `${PROJECT_PREFIX}/${baseUrl}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isArticle, project, type, data, isVKP, isCybersport]);

    const table = useMemo(() => ([
        {
            Header: 'Заголовок',
            accessor: 'title',
            minWidth: 400,
            Cell: (row) => (
                <div>
                    <Link to={`${buildStoryAdminUrl({ id: row.row.id })}edit`}>
                        {row.row.title}
                    </Link>
                </div>

            ),
        }, {
            Header: 'Статус',
            accessor: 'is_published',
            maxWidth: 160,
            Cell: (row) => (type !== 'static' || permissions.endpoints.includes('admin')) && (
                <span>
                    <span style={{
                        color: row.value === false ? '#ff2e00'
                            : '#57d500',
                        transition: 'all .3s ease',
                    }}
                    >
                        &#x25cf;

                    </span>
                    { row.value ? (
                        <span>
                            &nbsp;Опубликовано
                            <Button
                                key={type}
                                className={`table__publish-btn ${type === 'file' ? 'table__publish-btn_disabled' : ''}`}
                                size="sm"
                                variant="link"
                                id={row.value}
                                title="Снять с публикации"
                                onClick={handleItemPublish}
                                data-published={row.value}
                                data-id={row.row.id}
                                data-type={type}
                                data-article={isArticle}
                            >
                                <FontAwesomeIcon icon="times" />
                            </Button>
                        </span>
                    ) : (
                        <span>
                            &nbsp;В работе
                            <Button
                                className={`table__publish-btn ${type === 'file' ? 'table__publish-btn_disabled' : ''}`}
                                size="sm"
                                variant="link"
                                id={row.value}
                                title="Опубликовать"
                                onClick={handleItemPublish}
                                data-published={row.value}
                                data-id={row.row.id}
                                data-type={type}
                                data-article={isArticle}
                            >
                                <FontAwesomeIcon icon="check" />
                            </Button>
                        </span>
                    )}
                </span>
            ),
        }, {
            Header: 'Дата изменения',
            accessor: 'modified_at',
            Cell: (row) => (formatDateTime(row.value)),
            maxWidth: 170,
        }, {
            Header: 'Дата публикации',
            accessor: 'date_published',
            Cell: (row) => (formatDateTime(row.value)),
            maxWidth: 170,
        }, {
            Header: 'Просм.',
            accessor: 'views',
            maxWidth: 70,
        }, {
            Header: '',
            accessor: 'id',
            maxWidth: 40,
            Cell: (row) => (type !== 'static' || permissions.endpoints.includes('admin')) && (
                <Button
                    size="sm"
                    variant="link"
                    id={row.value}
                    data-title={row.original.title}
                    onClick={handleItemRemove}
                >
                    <FontAwesomeIcon id={row.value} icon="trash" />
                </Button>
            ),
        },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ]), [buildStoryAdminUrl, buildStoryUrl, handleItemPublish, handleItemRemove, isArticle, type, project, isVKP, isCybersport, permissions]);

    function handleItemPublish(e) {
        publisher(e, clearResults);
    }

    function handleItemRemove(e) {
        const { id, dataset } = e.currentTarget;

        if (window.confirm(`Внимание! Вы действительно хотите удалить ${dataset.title || ''}?`)) {
            Fetcher(`${API_ENDPOINT.replace('?', '') + id}/`, 'DELETE', clearResults);
        }
    }

    function handleFilterChange(e) {
        const { id, value } = e.currentTarget;

        const filter_params = {};

        filter_params[id] = value;

        const filter = {
            ...data.filter,
            ...filter_params,
        };

        let API_ENDPOINT_QS = '';

        Object.keys(filter).map((key, i) => {
            if (i !== 0) {
                API_ENDPOINT_QS += '&';
            } else {
                API_ENDPOINT_QS += API_PARAMS && API_PARAMS.includes('?') ? '&' : '?';
            }

            API_ENDPOINT_QS += `${key}=${filter[key]}`;
        });

        setData({
            ...data,
            filter,
            API_ENDPOINT_QS,
        });
    }

    function handleFilterCleanup() {
        setData({
            ...data,
            filter: {},
            API_ENDPOINT_QS: '',
        });
    }

    function clearResults() {
        setData({
            ...data,
            results: [],
        });
    }

    function handleFormSubmit(e) {
        e.preventDefault();
    }

    const gofTables = [
        {
            id: 0,
            allowedCategory: 'main',
            title: 'Главная GoF',
        },
        {
            id: 1,
            allowedCategory: 'about',
            title: 'О проекте',
        },
        {
            id: 2,
            allowedCategory: 'discipline',
            title: 'Дисциплины',
        },
        {
            id: 3,
            allowedCategory: 'other',
            title: 'Прочее',
        },
    ];

    return (
        <div className="container-fluid">
            <Row className="mb-2">
                <Col md={12}>
                    <NewEntityButton to={`/${project}/story/${type}/new`} />
                </Col>
            </Row>
            <Row className="mb-2">
                <Col md={12}>
                    <Form inline onSubmit={handleFormSubmit}>
                        <FormGroup>
                            <InputField
                                className="mr-2"
                                value={data.filter.search || ''}
                                label="Поиск "
                                name="search"
                                placeholder="Заголовок"
                                onChange={handleFilterChange}
                            />
                            <Button variant="outline-secondary" onClick={handleFilterCleanup}>
                                Сбросить
                            </Button>
                        </FormGroup>
                    </Form>
                </Col>
            </Row>
            { permissions?.endpoints?.length && gofProject ? gofTables.map((el) => (
                <div key={el.id}>
                    <h3>{ el.title }</h3>
                    <TableScreenWithoutUpdate
                        key={`${type}-${isVKP}-${isCybersport}`}
                        allowedCategory={el.allowedCategory}
                        columns={table}
                        endpoint={API_ENDPOINT + API_PARAMS + data.API_ENDPOINT_QS}
                        data={data}
                    />
                </div>
            )) : permissions?.endpoints?.length && (
                <TableScreenWithoutUpdate
                    key={`${type}-${isVKP}-${isCybersport}`}
                    columns={table}
                    endpoint={API_ENDPOINT + API_PARAMS + data.API_ENDPOINT_QS}
                    data={data}
                />
            )}
        </div>
    );
}
